<div class="h-1 w-full" *ngIf="!loaded">
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</div>
<div class="flex flex-col w-full preview-property-summary overflow-y-auto overflow-x-hidden zuper-scrollbar primary-font"
    *ngIf="loaded">
    <div class="relative w-full p-6 pt-7 pb-4 bg-accent-100 flex-shrink-0 dark:bg-accent-700 z-0 border-b">
        <img class="absolute inset-0 object-cover w-full h-full image-filter-blur"
            *ngIf="organizationDetails.organization_logo" src="{{organizationDetails.organization_logo}}" alt="">
        <div class="flex items-center justify-end w-full max-w-3xl mx-auto">
            <button mat-icon-button matTooltip="{{'close.text' | translate}}"
                matTooltipPosition="above"
                class="mat-focus-indicator mat-tooltip-trigger mat-icon-button mat-button-base" tabindex="0"
                (click)="closeDrawer()">
                <mat-icon role="img" class="mat-icon notranslate mat-icon-no-color" aria-hidden="true"
                    data-mat-icon-type="svg" data-mat-icon-name="x" data-mat-icon-namespace="heroicons_outline">
                    <em class="ti ti-x"></em>
                </mat-icon>
            </button>
        </div>
        <div class="relative flex w-full mt-4">
            <div
                class="ml-auto cursor-default inline-flex px-2 py-0.5 rounded text-base bg-gray-100 text-gray-600 border">
                <span class="mt-1">
                    <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-circle"
                        [ngClass]="{ 'icon-status-active': organizationDetails.is_active, 'icon-status-inactive': !organizationDetails.is_active }"
                        width="11" height="11" viewBox="0 0 24 24" stroke-width="0" stroke="currentColor" fill="none"
                        stroke-linecap="round" stroke-linejoin="round">
                        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                        <circle cx="12" cy="12" r="9"></circle>
                    </svg>
                </span>
                <span class="text-md font-medium px-1 truncate">
                    {{(organizationDetails.is_active ? 'active.text' :
                    'text.inactive')
                    | translate}}
                </span>
            </div>
        </div>
    </div>
    <div class="-mt-12 flow-root px-4 sm:-mt-8 sm:flex sm:items-end sm:px-6 pb-2 z-10">
        <div class="-m-1 flex">
            <div class="inline-flex overflow-hidden rounded-lg border-4 border-white shadow-md flex-shrink-0">
                <img *ngIf="organizationDetails.organization_logo"
                    class="h-30 w-30 flex-shrink-0 sm:h-30 sm:w-30 lg:h-30 lg:w-30"
                    src="{{organizationDetails.organization_logo}}" alt="">
                <img *ngIf="!organizationDetails.organization_logo"
                    class="h-30 w-30 flex-shrink-0 sm:h-30 sm:w-30 lg:h-30 lg:w-30"
                    src="assets/images/png/organization.png" alt="">
            </div>
        </div>
        <div class="m-4 sm:ml-6 sm:flex-1 w-2/4">
            <div class="flex items-center">
                <h3 class="text-xl font-bold text-gray-900 sm:text-2xl truncate"
                    matTooltip="{{organizationDetails.organization_name}}">
                    {{organizationDetails.organization_name}}</h3>
            </div>
            <p class="text-base text-gray-500 mt-1 truncate" *ngIf="organizationDetails.organization_email">
                <a target="_blank" href="mailto:{{organizationDetails.organization_email}}">
                    {{organizationDetails.organization_email}}
                </a>
            </p>
        </div>
        <div class="my-6 ml-auto">
            <a target="_blank" class="hidden" #viewOrganizationDetails href="{{getRedirectLink()}}"></a>
            <button mat-icon-button matTooltip="{{'text.view_details.new_tab' | translate}}"
                matTooltipPosition="above" (click)="viewOrganizationDetails.click($event)">
                <mat-icon class="icon-size-6">open_in_new</mat-icon>
            </button>
        </div>
    </div>
    <div class="flex flex-col w-full z-10">
        <div class="flex flex-col space-y-6 py-4 w-full border-b">
            <div class="flex px-5" *ngIf="organizationDetails.organization_description">
                <mat-icon role="img" class="mat-icon notranslate mat-icon-no-color" aria-hidden="true"
                    data-mat-icon-type="svg" data-mat-icon-name="mail" data-mat-icon-namespace="heroicons_outline">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" fit=""
                        height="100%" width="100%" preserveAspectRatio="xMidYMid meet" focusable="false">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M4 6h16M4 12h16M4 18h7"></path>
                    </svg>
                </mat-icon>
                <div class="min-w-0 ml-6 space-y-1">
                    <div class="flex leading-6">
                        <span class="text-base text-gray-700 font-medium tinymce-text-inner-html" [innerHTML]="organizationDetails.organization_description
                                                    | safeHtml: false"></span>
                    </div>
                </div>
            </div>
        </div>
        <mat-accordion>
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title class="text-secondary font-bold text-base primary-font">
                        {{'organization.preview.panel.address_header' | translate}}
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="px-6 py-2 primary-font"
                    *ngIf="organizationDetails.organization_address && (organizationDetails.organization_address.street || organizationDetails.organization_address.state)">
                    <div class="flex h-12">
                        <p class="font-bold leading-5 truncate text-base text-gray-600 flex items-center ml-1">
                            {{'text.service_address' | translate}}</p>
                        <span class="cursor-pointer z-50 ml-auto"
                            *ngIf="organizationDetails.organization_address.geo_cordinates?.length > 1"
                            [matTooltip]="('text.view_on_map' | translate)"
                            matTooltipPosition="left">
                            <a class="flex items-center justify-center rounded-full h-10 w-10 p-2 hover:bg-gray-200 text-primary-500 cursor-pointer"
                                target="_blank"
                                href="{{utilityService.getMapsCoordinatesUrl(organizationDetails.organization_address.geo_cordinates[0], organizationDetails.organization_address.geo_cordinates[1])}}">
                                <em class="ti ti-location icon-size-4.5 font-semibold"></em>
                            </a>
                        </span>
                    </div>
                    <div class="px-3 text-gray-500 font-medium">
                        <p *ngIf="organizationDetails.organization_address.street" class="text-base mb-2">
                            {{organizationDetails.organization_address.street}}</p>
                        <p *ngIf="organizationDetails.organization_address.landmark" class="text-base mb-2">
                            {{organizationDetails.organization_address.landmark}}</p>
                        <p *ngIf="organizationDetails.organization_address.city" class="text-base mb-2">
                            {{organizationDetails.organization_address.city}}</p>
                        <p *ngIf="organizationDetails.organization_address.state" class="text-base mb-2">
                            {{organizationDetails.organization_address.state}}
                            {{organizationDetails.organization_address.zip_code ? '- ' +
                            organizationDetails.organization_address.zip_code : '' }}</p>
                        <p *ngIf="organizationDetails.organization_address.country" class="text-base">
                            {{organizationDetails.organization_address.country}}</p>
                    </div>
                </div>
                <div class="px-6 py-2 border-t primary-font"
                    *ngIf="organizationDetails.organization_billing_address && (organizationDetails.organization_billing_address.street || organizationDetails.organization_billing_address.state)">
                    <div class="flex h-12">
                        <p class="font-bold leading-5 truncate text-base text-gray-600 flex items-center ml-1">
                            {{'billing.address.text' | translate}}</p>
                        <span class="cursor-pointer z-50 ml-auto"
                            *ngIf="organizationDetails.organization_billing_address.geo_cordinates"
                            [matTooltip]="('text.view_on_map' | translate)" matTooltipPosition="left">
                            <a class="flex items-center justify-center rounded-full h-10 w-10 p-2 hover:bg-gray-200 text-primary-500 cursor-pointer"
                                target="_blank"
                                href="{{utilityService.getMapsCoordinatesUrl(organizationDetails.organization_billing_address.geo_cordinates[0], organizationDetails.organization_billing_address.geo_cordinates[1])}}">
                                <em class="ti ti-location icon-size-4.5 font-semibold"></em>
                            </a>
                        </span>
                    </div>
                    <div class="px-3 text-gray-500 font-medium">
                        <p *ngIf="organizationDetails.organization_billing_address.street" class="text-base mb-2">
                            {{organizationDetails.organization_billing_address.street}}</p>
                        <p *ngIf="organizationDetails.organization_billing_address.landmark" class="text-base mb-2">
                            {{organizationDetails.organization_billing_address.landmark}}</p>
                        <p *ngIf="organizationDetails.organization_billing_address.city" class="text-base mb-2">
                            {{organizationDetails.organization_billing_address.city}}</p>
                        <p *ngIf="organizationDetails.organization_billing_address.state" class="text-base mb-2">
                            {{organizationDetails.organization_billing_address.state}}
                            {{organizationDetails.organization_billing_address.zip_code ? '- ' +
                            organizationDetails.organization_billing_address.zip_code : '' }}</p>
                        <p *ngIf="organizationDetails.organization_billing_address.country" class="text-base">
                            {{organizationDetails.organization_billing_address.country}}</p>
                    </div>
                </div>
            </mat-expansion-panel>
        </mat-accordion>
        <mat-accordion>
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title class="text-secondary font-bold text-base primary-font">
                      {{'text.customers_associated' | translate}} 
                        {{customersCount ? '(' + customersCount +')' : ''}}
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="primary-font">
                    <customers-list [options]="getCustomerListOptions()" (eventEmitter)="eventEmitHandler($event)">
                    </customers-list>
                </div>
            </mat-expansion-panel>
        </mat-accordion>
        <mat-accordion class="border-b">
            <mat-expansion-panel [expanded]="jobsCount === 1">
                <mat-expansion-panel-header>
                    <mat-panel-title class="text-secondary font-bold text-base primary-font">
                        {{'text.jobs' | translate}} ({{jobsCount}})
                        <em class="ti ti-plus text-2xl ml-auto" (click)="createNewJob($event)"
                            matTooltip="{{'text.new_job' | translate}}"
                            *ngIf="isJobHasAccess && hasPermissionToCreateJob"></em>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <jobs-list [options]="getJobListOptions()" (eventEmitter)="jobEventEmitHandler($event)"></jobs-list>
                <div class="h-80 flex flex-col items-center justify-center primary-font" *ngIf="jobsCount === 0">
                    <div class="flex flex-col items-center justify-center">
                        <img class="w-40 m-auto" src="assets/images/svgs/no_organization_found.svg"
                            alt="Add a job for this organization">
                        <h4 class="font-medium mt-4 text-secondary">
                            {{'organization.preview.panel.noJobs_found' | translate}}</h4>
                        <h4 class="font-medium mt-2 cursor-pointer underline text-primary"
                            *ngIf="isJobHasAccess && hasPermissionToCreateJob"
                            (click)="createNewJob($event)">
                            {{'create.new_job.text' | translate}}</h4>
                    </div>
                </div>
            </mat-expansion-panel>
        </mat-accordion>
        <mat-accordion class="border-b" *ngFor="let key of object.keys(customFieldGroups)">
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title class="text-secondary font-bold text-base primary-font">
                        {{customFieldGroups[key].isDefaultGroup ? ('text.other_details' |
                        translate) :
                        customFieldGroups[key].headerName}}
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="pt-4 px-10 primary-font">
                    <custom-fields [options]="getcustomFieldOptions(customFieldGroups[key].custom_fields)"></custom-fields>
                </div>
            </mat-expansion-panel>
        </mat-accordion>
    </div>
</div>